import theme from '@styles/theme';
export default {
  storeContainer: {
    width: ['293px', '293px', '293px', '293px', '320px', '320px', '363px'],
    minHeight: '336px',
    maxWidth: ['293px', '293px', '293px', '293px', '320px', '320px', '363px'],
    flexShrink: 0,
    display: 'flex',
    flexFlow: 'column wrap',
    justifyContent: 'space-between',
    alignContent: 'space-between'
  },
  storeHeadingContainer: {
    minHeight: '62px',
    maxHeight: '94px'
  },
  storeAddressContainer: {
    minHeight: '125px',
    maxHeight: '206px'
  },
  spanText: {
    color: 'darkGrey700',
    fontWeight: theme.fontWeights.normal
  },
  address: {
    lineHeight: '140%',
    a: {
      textDecoration: 'underline',
      letterSpacing: '0.8px',
      color: theme.rawColors.darkGrey700,
      '&:hover': {
        textDecoration: 'underline',
        letterSpacing: '0.8px',
        color: theme.rawColors.neutralBlack
      }
    },
    span: {
      color: 'darkGrey700',
      fontWeight: theme.fontWeights.normal
    }
  },
  hours: {
    mt: '16px',
    color: 'darkGrey700',
    fontWeight: theme.fontWeights.normal
  },
  textRow: {
    display: 'block'
  },
  textRowPhone: {
    display: 'block',
    textTransform: 'lowercase'
  },
  about: {
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'flex-start',
    alignContent: 'space-between',
    justifyContent: 'center',
    height: '36px',
    width: '100%'
  },
  directionsLink: {
    height: 'auto',
    mt: 'unset'
  },
  directionsLinkText: {
    ml: '8px',
    textDecoration: 'underline'
  }
};